export default {"src":"/_next/static/media/tag-star.2fd6d981.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};